import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { nextOperationLoaderConfig } from '../constants/loader';
import { AvailableOperationTypes } from '../models/operations/available-operation-types';

@Injectable({
  providedIn: 'root',
})

export class LoadingProService {

  //Variable that shows and hides the loading
  isActive = new BehaviorSubject<boolean>(false);
  isNextOpActive = new BehaviorSubject<boolean>(false);
  isProcessRestarted = new BehaviorSubject<boolean>(false);
  signatureType: AvailableOperationTypes;
  operation: BehaviorSubject<Record<'text' | 'icon', string> | null> = new BehaviorSubject(null);

  public setLoader(state: boolean): void {
    this.isActive.next(state);
  }

  public setReprocessLoader(state: boolean): void {
    this.isProcessRestarted.next(state);
  }

  public setNextOperationLoader(state: boolean): void {
    this.isNextOpActive.next(state);
  }

  public getOperationTypeProps(operationType: AvailableOperationTypes): void {
    const operation = {
      text: nextOperationLoaderConfig[operationType]?.text,
      icon: nextOperationLoaderConfig[operationType]?.icon,
    }

    this.operation.next(operation);
  }
}
